import React, { useState, useCallback, useEffect, useMemo } from 'react';
import poweredByLogo from '../../assets/powered_by_chattitude.png';
import { API_URL } from '../../common/Constants';
import { useReseller } from '../../contexts/ResellerContext';

const DEFAULT_POWERED_BY_HREF = 'https://chattitude.com/';

function normalizeResellerBaseHref(url) {
  if (!url || !String(url).trim()) return null;
  const t = String(url).trim();
  if (/^https?:\/\//i.test(t)) return t;
  return `https://${t.replace(/^\/+/, '')}`;
}

const PoweredByChattitude = ({ tenantId, poweredByLogoUrl, poweredByLogoHref }) => {
  const { reseller } = useReseller();
  const apiLogoSrc = poweredByLogoUrl || (tenantId ? `${API_URL}/public/tenant/${tenantId}/powered-by-logo` : null);
  const [fallbackToDefault, setFallbackToDefault] = useState(false);
  const logoSrc = (apiLogoSrc && !fallbackToDefault) ? apiLogoSrc : poweredByLogo;

  // Match when we show (or attempt) reseller powered-by branding — same cases as apiLogoSrc for tenant embeds.
  const usesResellerPoweredByBranding = Boolean(poweredByLogoUrl?.trim())
    || (Boolean(tenantId) && Boolean(reseller?.poweredByLogoPath?.trim()));

  useEffect(() => {
    setFallbackToDefault(false);
  }, [tenantId, poweredByLogoUrl]);

  const handleError = useCallback(() => {
    if (apiLogoSrc) {
      setFallbackToDefault(true);
    }
  }, [apiLogoSrc]);

  const linkHref = useMemo(() => {
    if (fallbackToDefault || !usesResellerPoweredByBranding) {
      return DEFAULT_POWERED_BY_HREF;
    }
    const fromProp = poweredByLogoHref && String(poweredByLogoHref).trim();
    if (fromProp) return fromProp;
    if (reseller?.baseUrl) return normalizeResellerBaseHref(reseller.baseUrl) || DEFAULT_POWERED_BY_HREF;
    return DEFAULT_POWERED_BY_HREF;
  }, [fallbackToDefault, usesResellerPoweredByBranding, poweredByLogoHref, reseller?.baseUrl]);

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 0 5px 0',
        boxSizing: 'border-box',
        bottom: -32,
        right: 0,
        zIndex: 1000,
        background: 'transparent',
        userSelect: 'none',
      }}
    >
      <a
        href={linkHref}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', pointerEvents: 'auto' }}
      >
        <img
          src={logoSrc}
          alt="Powered by Chattitude"
          style={{ height: 15, marginRight: 8 }}
          onError={handleError}
        />
      </a>
    </div>
  );
};

export default PoweredByChattitude;
